import './users.scss';
import { useState, useEffect } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

function Users() {
  const axiosPrivate = useAxiosPrivate();
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const getAllUsers = async () => {
      try {
        const response = await axiosPrivate.get('/users');
        if (response?.data) {
          setUsersList(response.data);
          setSelectedUser(response.data[0]); // auto-select first user
        }
      } catch (err) {
        console.error('Error fetching users:', err);
      }
    };

    getAllUsers();
  }, [axiosPrivate]); 

  return (
    <div className="users">

      {/* Left panel */}
      <div className="users-list">
        <div className="list-header">
          <h3>All Users</h3>
          <button className="create-btn">
            + Add New User
          </button>
        </div>
        {usersList.length > 0 ? (
          usersList.map((user) => (
            <div
              key={user.username}
              className={`user-card ${
                selectedUser?.username === user.username ? 'active' : ''
              }`}
              onClick={() => setSelectedUser(user)}
            >
              {user.username}
            </div>
          ))
        ) : (
          <p>Loading users...</p>
        )}
      </div>

      {/* Right panel */}
      <div className="user-details">
        {selectedUser ? (
          <>
            <h2>{selectedUser.username}</h2>
            <p>
              <strong>Name:</strong> {selectedUser.fullName}
            </p>
            <p>
              <strong>Roles:</strong> {Array.isArray(selectedUser.roles)
                    ? selectedUser.roles.join(', ')
                    : typeof selectedUser.roles === 'object'
                      ? Object.keys(selectedUser.roles).join(', ')
                      : selectedUser.roles}
            </p>
            <p>
              <strong>Email:</strong> {selectedUser.userEmail}
            </p>
            
          </>
        ) : (
          <p>Select a user to view details</p>
        )}
      </div>
    </div>
  );
}

export default Users;
